// Stay on the scorer page until every persisted message has been acknowledged.
// Stop on a failed attempt without removing or recreating the pending messages.
export async function drainS3pQueue(pendingCount: () => Promise<number>, sync: () => Promise<void>) {
  let pending = await pendingCount()
  while (pending > 0) {
    await sync()
    const remaining = await pendingCount()
    if (remaining >= pending) throw new Error('S3P messages are still awaiting publication')
    pending = remaining
  }
}
